import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function announcementDataReducer(state = initialState.announcementData, action) {
  switch (action.type) {
    case types.LOADED_ANNOUNCEMENT_DATA_SUCCESS:
      return action.announcementData;
    default:
      return state;
  }
} 
